<template>
    <div>
        <div class="demo-inline-spacing text-center mb-2">
            <b-form-radio
                name="product-type"
                class="custom-control-primary mt-0"
                :value="modes.PRODUCT_REQUEST"
                v-model="mode"
                @change="onModeChange"
            >
                {{ $t('Page(SentRequest):Component(PageMode):product-request') }}
            </b-form-radio>
            <b-form-radio
                name="product-type"
                :value="modes.FOLLOW_UP"
                class="custom-control-primary mt-0"
                v-model="mode"
                @change="onModeChange"
            >
                {{ $t('Page(SentRequest):Component(PageMode):follow-up') }}
            </b-form-radio>
        </div>
        <ProductRequests
            v-if="mode === modes.PRODUCT_REQUEST"
        />
        <FollowUps
            v-else
        />
    </div>
</template>
<script>
import {BFormRadio} from 'bootstrap-vue'
import ProductRequests from "@/views/request/sent/ProductRequests.vue";
import FollowUps from "@/views/supply-chain/supplier/FollowUps.vue";

const modes = {
    PRODUCT_REQUEST: 'PRODUCT_REQUEST',
    FOLLOW_UP: 'FOLLOW_UP',
};

export default {
    components: { BFormRadio, ProductRequests, FollowUps, },
    data() {
        return {
            mode: this.$store.state.request.sent.requestsPage.mode,
            modes: this.$store.state.request.sent.requestsPage.modes,
        };
    },
    methods: {
        onModeChange() {
            this.$store.dispatch('saveSentRequestPageMode', this.mode);
        }
    },
}
</script>
